// WHICH CHANNEL AM I? Baked at build time, like every other VITE_* value.
//
// A staging build is a real build against a real database that is not production. Everything a
// person can do in it looks and behaves exactly like the real thing, which is the point -- and
// also the hazard. The only reliable defence is that you can never mistake one for the other at a
// glance.
//
// Two signals, deliberately redundant:
//   1. a CRIMSON accent, applied by overriding one CSS variable
//   2. a persistent bar that says so in words
//
// Colour alone is not enough: it is the thing you stop noticing after an hour, and roughly 8% of
// men cannot separate red from green reliably. Words alone are easy to scroll past. Together they
// are hard to miss.
//
// WHAT THIS DELIBERATELY DOES NOT TOUCH: --good, --bad, and every disposition colour. Those are
// SEMANTIC -- a map pin's colour states what happened at a door, and the disposition palette is
// locked. Repainting them would make staging lie about the thing you went to staging to check.
export type Channel = "production" | "staging";

export function channel(): Channel {
  return (import.meta.env.VITE_CHANNEL as string) === "staging" ? "staging" : "production";
}

/** Set the channel attribute and, off production, pin a banner to the top of the document.
 *  Injected straight into the DOM rather than rendered by a component, so the three apps share one
 *  implementation and no shell has to know this exists. */
export function initChannel(): void {
  const ch = channel();
  document.documentElement.dataset.channel = ch;
  if (ch === "production") return;
  if (document.getElementById("channel-banner")) return;
  // A FIXED OVERLAY, SO IT OCCUPIES NO LAYOUT SPACE. An in-flow bar made the document taller than
  // the viewport, and every attempt to compensate (measure it, subtract it from #root, override
  // min-h-screen, cancel a doubled status-bar inset) behaved differently in the APK than in the
  // PWA — Capacitor runs the WebView edge-to-edge so env() is real, while the browser insets the
  // viewport so env() is 0. Occupying zero height removes the entire problem instead of tracking
  // it: nothing to measure, nothing to observe, identical in both environments.
  const bar = document.createElement("div");
  bar.id = "channel-banner";
  const chip = document.createElement("span");
  // A real element, not a CSS ::before — the warning has to reach a screen reader too.
  chip.textContent = "DEMO — staging data";
  bar.appendChild(chip);
  document.body.prepend(bar);
}
